(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["smart-buybox"] && !Shopify.designMode) return;
  try {
    (function() {
    // ─── Helpers ────────────────────────────────────────────────────
    function fmt(n) {
      // Preferir formatMoney de PROPEL_KITS
      if (window.PROPEL_KITS && typeof window.PROPEL_KITS.formatMoney === 'function') {
        return window.PROPEL_KITS.formatMoney(n);
      }
      var v = Math.round(n || 0);
      return '$' + v.toLocaleString('es-MX');
    }
    function num(value, fallback) {
      var n = parseFloat(value);
      return isNaN(n) ? fallback : n;
    }
    function intNum(value, fallback) {
      var n = parseInt(value, 10);
      return isNaN(n) ? fallback : n;
    }

    // ─── readSettings · prioriza PROPEL_KITS con fallback a dataset ──
    function readSettings(container) {
      var d = container.dataset;
      var K = window.PROPEL_KITS;

      // Volume map — de PROPEL_KITS o del dataset local
      var volMap;
      if (K && typeof K.getVolumeMap === 'function') {
        volMap = K.getVolumeMap();
      } else {
        // Fallback: nueva estructura 3/5/7/9
        volMap = {
          3: num(d.volume3pPct, 3),
          5: num(d.volume5pPct, 6),
          7: num(d.volume7pPct, 12),
          9: num(d.volume9pPct, 15)
        };
      }

      return {
        basePrice: (K && K.config.basePricePerPouch) || num(d.basePrice, 159),
        ship1: (K && K.config.shippingBasePrice) || num(d.shipping1p, 100),
        ship2: (K && K.config.shippingBasePrice) || num(d.shipping2p, 100),
        freeThreshold: (K && K.config.freeShipThreshold) || intNum(d.freeShipThreshold, 5),
        samplingThreshold: (K && K.config.samplingThreshold) || intNum(d.samplingThreshold, 3),
        volumeMap: volMap,
        defaultPctMensual: (K && K.config.subDiscounts.mensual) || num(d.discountMensualPct, 5),
        defaultPctQuincenal: (K && K.config.subDiscounts.quincenal) || num(d.discountQuincenalPct, 10),
        defaultPctSemanal: (K && K.config.subDiscounts.semanal) || num(d.discountSemanalPct, 15),
        subShippingDiscountPct: (K && K.config.subShippingDiscountPct) || num(d.subShippingDiscountPct, 50),
        savingsBaselinePerPouch: num(d.savingsBaselinePerPouch, 190),
        welcomeEnabled: (K && K.config.welcomeEnabled) || (d.welcomeEnabled === '1'),
        welcomePct: (K && K.config.welcomePct) || num(d.welcomePct, 30)
      };
    }

    // ─── Pricing core (Option A · mirror Shopify + PROPEL_KITS) ─────
    function getVolumePct(tierEl, settings) {
      var items = parseInt(tierEl.dataset.paidPouches || tierEl.dataset.itemsCount, 10) || 1;
      // 1) Override per-tier
      var override = parseFloat(tierEl.dataset.volumePct);
      if (!isNaN(override) && override > 0) return override;

      // 2) PROPEL_KITS helper (tier matching)
      if (window.PROPEL_KITS && typeof window.PROPEL_KITS.getVolumePctForPouches === 'function') {
        return window.PROPEL_KITS.getVolumePctForPouches(items);
      }

      // 3) Threshold table fallback (nueva estructura 3/5/7/9)
      var map = settings.volumeMap || {};
      if (items >= 9) return map[9] || 0;
      if (items >= 7) return map[7] || 0;
      if (items >= 5) return map[5] || 0;
      if (items >= 3) return map[3] || 0;
      return 0;
    }

    function computeProducto(tierEl, settings) {
      // paidPouches = items_count - bonus_pouches. Si no está seteado, usar items_count.
      var paid = parseInt(tierEl.dataset.paidPouches, 10);
      if (isNaN(paid) || paid < 1) paid = parseInt(tierEl.dataset.itemsCount, 10) || 1;
      var volPct = getVolumePct(tierEl, settings);
      return settings.basePrice * paid * (1 - volPct / 100);
    }

    function computeVolumeDiscount(tierEl, settings) {
      var paid = parseInt(tierEl.dataset.paidPouches, 10);
      if (isNaN(paid) || paid < 1) paid = parseInt(tierEl.dataset.itemsCount, 10) || 1;
      var volPct = getVolumePct(tierEl, settings);
      if (volPct <= 0) return 0;
      return settings.basePrice * paid * (volPct / 100);
    }

    function computeEnvio(items, settings, tierEl) {
      if (tierEl && tierEl.dataset.envio !== undefined) {
        var v = parseFloat(tierEl.dataset.envio);
        return isNaN(v) ? 0 : v;
      }
      if (items >= settings.freeThreshold) return 0;
      if (items === 1) return settings.ship1;
      return settings.ship2;
    }

    function getSubDiscountPct(settings, freqName) {
      var key = detectFreqKey(freqName);
      if (!key) return 0;
      var defaultKey = 'defaultPct' + key.charAt(0).toUpperCase() + key.slice(1);
      return settings[defaultKey] || 0;
    }

    function detectFreqKey(freqName) {
      if (window.PROPEL_KITS && typeof window.PROPEL_KITS.detectSubFrequency === 'function') {
        return window.PROPEL_KITS.detectSubFrequency(freqName);
      }
      if (!freqName) return null;
      var n = String(freqName).toLowerCase();
      if (n.indexOf('semanal') !== -1) return 'semanal';
      if (n.indexOf('quincenal') !== -1) return 'quincenal';
      if (n.indexOf('mensual') !== -1) return 'mensual';
      return null;
    }

    function calcTier(tierEl, settings, freqPct, freqName) {
      // ─── SEMÁNTICA (2026-07 fix) ─────────────────────────────────
      // paidPouches = pouches PAGADOS (base del pricing)
      // bonusPouches = pouches BONUS/GRATIS
      // totalPouchesReceived = paid + bonus (denominador del per_pouch)
      //
      // Lectura defensiva: si data-total-pouches no está seteado (versión
      // vieja del block), lo derivamos de paid + bonus.
      var paidPouches = parseInt(tierEl.dataset.paidPouches, 10);
      if (isNaN(paidPouches) || paidPouches < 1) {
        paidPouches = parseInt(tierEl.dataset.itemsCount, 10) || 1;
      }
      var bonusPouches = parseInt(tierEl.dataset.bonusPouches, 10) || 0;
      var totalPouchesReceived = parseInt(tierEl.dataset.totalPouches, 10);
      if (isNaN(totalPouchesReceived) || totalPouchesReceived < 1) {
        totalPouchesReceived = paidPouches + bonusPouches;
      }

      var producto = computeProducto(tierEl, settings);           // = raw × (1 - vol%)
      var volumeDiscount = computeVolumeDiscount(tierEl, settings);
      var rawPouchesPrice = settings.basePrice * paidPouches;      // raw sin descuentos

      // ONE-TIME (aplica volumen · envío por threshold PAID)
      var envio = computeEnvio(paidPouches, settings, tierEl);
      var onetimeTotal = producto + envio;

      // SUB — MODELO 2026-07 (NO stackea con volumen)
      // El % de sub aplica al RAW price (reemplaza a vol %).
      // Ej Kit 5+1 sub semanal 20%: 5 × $159 × 0.80 = $636 (NO × 0.94)
      // Esto matchea el subtotal recurrente de Shopify que solo aplica el
      // Selling Plan % de Seal (sin Automatic Discounts de volumen).
      var subPct = getSubDiscountPct(settings, freqName);
      if (subPct === 0 && freqPct > 0) subPct = freqPct;
      var subProducto = rawPouchesPrice * (1 - subPct / 100);
      var shipDiscPct = settings.subShippingDiscountPct || 0;
      var envioSub = envio * (1 - shipDiscPct / 100);
      var subTotal = Math.round(subProducto + envioSub);

      // ─── PER POUCH · SOLO costo de pouches (SIN envío) ───────────────
      // El precio por pouch refleja solo lo que cuesta el producto, no el envío.
      // Esto le da al cliente una comparación justa entre kits y una
      // referencia clara de "cuánto cuesta cada comida" sin distorsión logística.
      //
      // One-time: cliente NO recibe bonus → producto / paid
      // Sub: cliente SÍ recibe bonus → subProducto / (paid + bonus)
      //
      // Ejemplos (Kit 3p con $100 envío es donde más notable):
      //   Kit 3p one-time: producto $463 / 3 = $154/pouch (antes con envío $188)
      //   Kit 3p sub sem: subProducto $381 / 3 = $127/pouch (antes con envío $144)
      //   Kit 5+1 one-time: $747 / 5 = $149/pouch (sin envío, igual)
      //   Kit 5+1 sub sem: $636 / 6 = $106/pouch (sin envío, igual)
      //   Kit 7+2 one-time: $1013 / 7 = $145/pouch (sin envío, igual)
      //   Kit 7+2 sub sem: $890 / 9 = $99/pouch (sin envío, igual)
      var onetimePerPouch = paidPouches > 0 ? Math.round(producto / paidPouches) : 0;
      var subPerPouch = totalPouchesReceived > 0 ? Math.round(subProducto / totalPouchesReceived) : 0;

      var baseline = (settings.savingsBaselinePerPouch || 0) * totalPouchesReceived;
      var ahorra = Math.max(0, baseline - subTotal);

      // ─── AHORROS vs list_full_price ──────────────────────────────
      // MODELO 2026-07: BOGO solo en sub. One-time no recibe bonus,
      // así que su ahorro NO incluye el valor de los bonus pouches.
      //
      // One-time (recibe solo PAID pouches):
      //   listPrice = paid × $base + envío
      //   savings = listPrice - onetimeTotal (solo por descuento de volumen)
      //   Ej Kit 5+1 one-time: $795 - $747 = $48 (6% de volume)
      //   Ej Kit 7+2 one-time: $1,113 - $1,013 = $100 (9% de volume)
      //
      // Sub (recibe PAID + BONUS):
      //   listPriceWithBonus = (paid + bonus) × $base + envío
      //   savings = listPriceWithBonus - subTotal (sub discount + valor bonus)
      //   Ej Kit 5+1 sub semanal: $954 - $636 = $318 (33% de valor total)
      //   Ej Kit 7+2 sub semanal: $1,431 - $890 = $541 (38% de valor total)
      var bonusValue = bonusPouches * settings.basePrice;

      // Compare-at listPrice para one-time = solo PAID (no bonus)
      var onetimeListPrice = (settings.basePrice * paidPouches) + envio;
      var onetimeSavings = Math.max(0, onetimeListPrice - onetimeTotal);
      var onetimeSavingsPct = onetimeListPrice > 0
        ? Math.round((onetimeSavings / onetimeListPrice) * 100)
        : 0;

      // Compare-at listPrice para sub = PAID + BONUS (cliente recibe todos)
      var subListPriceWithBonus = onetimeListPrice + bonusValue;
      var subSavingsRaw = Math.max(0, onetimeListPrice - subTotal);   // ahorro real en $ vs same paid count
      var subSavings = subSavingsRaw + bonusValue;                     // + valor de los bonus recibidos
      var subSavingsPct = subListPriceWithBonus > 0
        ? Math.round((subSavings / subListPriceWithBonus) * 100)
        : 0;

      // Compat backward: mantener listFullPrice + totalListWithBonus para consumers
      var listFullPrice = onetimeListPrice;
      var totalListWithBonus = subListPriceWithBonus;

      return {
        items: totalPouchesReceived,
        paidPouches: paidPouches,
        bonusPouches: bonusPouches,
        totalPouchesReceived: totalPouchesReceived,
        producto: producto, envio: envio, envioSub: envioSub,
        onetimeTotal: onetimeTotal, subTotal: subTotal,
        onetimePerPouch: onetimePerPouch, subPerPouch: subPerPouch,
        ahorra: ahorra, volumeDiscount: volumeDiscount,
        listFullPrice: listFullPrice,
        onetimeListPrice: onetimeListPrice,           // NEW: compare-at para one-time (no bonus)
        subListPriceWithBonus: subListPriceWithBonus, // NEW: compare-at para sub (con bonus)
        totalListWithBonus: totalListWithBonus,       // legacy alias de subListPriceWithBonus
        onetimeSavings: onetimeSavings, subSavings: subSavings,
        onetimeSavingsPct: onetimeSavingsPct, subSavingsPct: subSavingsPct
      };
    }

    function getCurrentFreqPct(container) {
      var activePill = container.querySelector('.sbb-global-freq-pills .sbb-frequency-pill.is-active');
      if (!activePill) return 0;
      return parseFloat(activePill.dataset.pct) || 0;
    }

    function getCurrentFreqName(container) {
      var activePill = container.querySelector('.sbb-global-freq-pills .sbb-frequency-pill.is-active');
      return activePill ? (activePill.dataset.planName || 'Suscripción') : 'Suscripción';
    }

    function getCurrentFreqPlanId(container) {
      var activePill = container.querySelector('.sbb-global-freq-pills .sbb-frequency-pill.is-active');
      return activePill ? (activePill.dataset.planId || '') : '';
    }

    function renderTier(tierEl, settings, freqPct, freqName) {
      var p = calcTier(tierEl, settings, freqPct, freqName);

      var onetimeCol = tierEl.querySelector('.sbb-mode-col-onetime');
      var subCol = tierEl.querySelector('.sbb-mode-col-sub');

      var saveFormat = tierEl.dataset.saveFormat || 'Ahorra {amount}';
      // Textos de envío: si están vacíos, se oculta el elemento .sbb-mode-extra
      // (no forzamos default para respetar la config del merchant)
      var onetimeTextNoShip = tierEl.dataset.onetimeTextNoShip || '';
      var onetimeTextWithShip = tierEl.dataset.onetimeTextWithShip || '';

      function applyPlaceholder(format, key, value) {
        return String(format)
          .split('[' + key + ']').join(value)
          .split('{' + key + '}').join(value);
      }

      var onetimeCompareOverride = parseFloat(tierEl.dataset.onetimeCompare);
      var subCompareOverride = parseFloat(tierEl.dataset.subCompare);
      // Compare-at por modo (FIX 2026-07):
      //   one-time = onetimeListPrice (sin bonus, cliente no lo recibe)
      //   sub      = subListPriceWithBonus (con bonus, cliente sí lo recibe)
      var onetimeCompare = (!isNaN(onetimeCompareOverride) && onetimeCompareOverride > 0)
        ? onetimeCompareOverride : p.onetimeListPrice;
      var subCompare = (!isNaN(subCompareOverride) && subCompareOverride > 0)
        ? subCompareOverride : p.subListPriceWithBonus;

      function buildSavesBadge(amount, pct, format) {
        if (amount <= 0) return '';
        var labelText = applyPlaceholder(format, 'amount', fmt(amount));
        var pctHtml = pct > 0
          ? ' <span class="sbb-saves-pct">−' + pct + '%</span>'
          : '';
        return labelText + pctHtml;
      }

      if (onetimeCol) {
        var priceEl = onetimeCol.querySelector('.sbb-mode-price');
        if (priceEl) priceEl.textContent = fmt(p.onetimeTotal);
        var pp = onetimeCol.querySelector('.sbb-mode-per-pouch');
        if (pp) pp.textContent = fmt(p.onetimePerPouch) + ' / pouch';
        var extra = onetimeCol.querySelector('.sbb-mode-extra');
        if (extra) {
          var extraText = '';
          if (p.envio === 0) extraText = onetimeTextNoShip;
          else if (onetimeTextWithShip) extraText = applyPlaceholder(onetimeTextWithShip, 'amount', fmt(p.envio));
          if (extraText && extraText.trim() !== '') {
            extra.textContent = extraText;
            extra.style.display = '';
          } else {
            extra.textContent = '';
            extra.style.display = 'none';
          }
        }
        var compEl = onetimeCol.querySelector('.sbb-mode-compare');
        if (compEl) {
          if (onetimeCompare > p.onetimeTotal) {
            compEl.textContent = fmt(onetimeCompare);
            compEl.style.display = '';
          } else {
            compEl.style.display = 'none';
          }
        }
        var oneSaves = onetimeCol.querySelector('.sbb-mode-saves');
        if (oneSaves) {
          var html = buildSavesBadge(p.onetimeSavings, p.onetimeSavingsPct, saveFormat);
          if (html) {
            oneSaves.innerHTML = html;
            oneSaves.style.display = '';
          } else {
            oneSaves.style.display = 'none';
          }
        }
      }
      if (subCol) {
        var sp = subCol.querySelector('.sbb-mode-price');
        if (sp) sp.textContent = fmt(p.subTotal);
        var spp = subCol.querySelector('.sbb-mode-per-pouch');
        if (spp) spp.textContent = fmt(p.subPerPouch) + ' / pouch';
        var saves = subCol.querySelector('.sbb-mode-saves');
        if (saves) {
          var subHtml = buildSavesBadge(p.subSavings, p.subSavingsPct, saveFormat);
          if (subHtml) {
            saves.innerHTML = subHtml;
            saves.style.display = '';
          } else {
            saves.style.display = 'none';
          }
        }
        var subCompEl = subCol.querySelector('.sbb-mode-compare');
        if (subCompEl) {
          if (subCompare > p.subTotal) {
            subCompEl.textContent = fmt(subCompare);
            subCompEl.style.display = '';
          } else {
            subCompEl.style.display = 'none';
          }
        }
      }

      tierEl.dataset.computedItems = p.items;                          // total recibidos (paid + bonus)
      tierEl.dataset.computedPaidPouches = p.paidPouches;
      tierEl.dataset.computedBonusPouches = p.bonusPouches;
      tierEl.dataset.computedTotalPouches = p.totalPouchesReceived;    // = computedItems, más semántico
      tierEl.dataset.computedProducto = p.producto;
      tierEl.dataset.computedEnvio = p.envio;
      tierEl.dataset.computedEnvioSub = p.envioSub;
      tierEl.dataset.computedOnetimeTotal = p.onetimeTotal;
      tierEl.dataset.computedSubTotal = p.subTotal;
      tierEl.dataset.computedOnetimePerPouch = p.onetimePerPouch;      // NEW: para debug
      tierEl.dataset.computedSubPerPouch = p.subPerPouch;              // NEW: para debug
      tierEl.dataset.computedAhorra = p.subSavings;
      tierEl.dataset.computedOnetimeSavings = p.onetimeSavings;
      tierEl.dataset.computedListFullPrice = p.listFullPrice;
      tierEl.dataset.computedTotalListWithBonus = p.totalListWithBonus;
      tierEl.dataset.computedVolumeDiscount = p.volumeDiscount;

      reflectActiveMode(tierEl);
    }

    function reflectActiveMode(tierEl) {
      var mode = tierEl.dataset.activeMode || 'sub';
      if (mode === 'sub') {
        var subShip = parseFloat(tierEl.dataset.computedEnvioSub);
        tierEl.dataset.computedTotal = tierEl.dataset.computedSubTotal;
        tierEl.dataset.computedShipping = isNaN(subShip) ? 0 : subShip;
        tierEl.dataset.computedDiscount = tierEl.dataset.computedAhorra;
        tierEl.dataset.computedSavings = tierEl.dataset.computedAhorra;
        tierEl.dataset.computedSubtotal = tierEl.dataset.computedSubTotal;
        tierEl.dataset.computedDiscLabel = 'Suscripción';
      } else {
        tierEl.dataset.computedTotal = tierEl.dataset.computedOnetimeTotal;
        tierEl.dataset.computedShipping = tierEl.dataset.computedEnvio;
        var producto = parseFloat(tierEl.dataset.computedProducto) || 0;
        tierEl.dataset.computedDiscount = 0;
        tierEl.dataset.computedSavings = 0;
        tierEl.dataset.computedSubtotal = producto;
        tierEl.dataset.computedDiscLabel = '';
      }
    }

    function publishBuyboxPreview(container) {
      var selected = container.querySelector('.sbb-card.selected');
      if (!selected) return;
      var items = parseInt(
        selected.dataset.computedItems || selected.dataset.itemsCount,
        10
      ) || 0;
      var mode = selected.dataset.activeMode || 'sub';
      var subActive = (mode === 'sub');

      if (window.PROPEL_ZONES && typeof window.PROPEL_ZONES.setBuyboxPreview === 'function') {
        window.PROPEL_ZONES.setBuyboxPreview({ items: items, subActive: subActive });
      }
      document.dispatchEvent(new CustomEvent('propel:buybox-preview', {
        detail: { items: items, subActive: subActive, source: 'smart-buybox' }
      }));
    }

    function selectModeCol(modeColEl) {
      var tierEl = modeColEl.closest('.sbb-card');
      if (!tierEl || tierEl.classList.contains('sbb-card-empty')) return;
      var container = tierEl.closest('.sbb-container');
      if (!container) return;

      container.querySelectorAll('.sbb-card.selected').forEach(function(c) { c.classList.remove('selected'); });
      container.querySelectorAll('.sbb-mode-col.is-selected').forEach(function(m) { m.classList.remove('is-selected'); });

      tierEl.classList.add('selected');
      modeColEl.classList.add('is-selected');
      var mode = modeColEl.dataset.mode || 'sub';
      tierEl.dataset.activeMode = mode;

      if (mode === 'sub') {
        var planId = getCurrentFreqPlanId(container);
        if (planId) tierEl.dataset.sellingPlanId = planId;
      } else {
        tierEl.dataset.sellingPlanId = '';
      }

      reflectActiveMode(tierEl);
      syncFormInputs(tierEl);
      updateFrequencyDisabledState(container);
      updateTotalBox(container);
      publishBuyboxPreview(container);
    }

    function updateFrequencyDisabledState(container) {
      var freqBlock = container.querySelector('.sbb-global-freq');
      if (!freqBlock) return;
      var selected = container.querySelector('.sbb-card.selected');
      var mode = selected ? (selected.dataset.activeMode || 'sub') : 'sub';
      if (mode === 'onetime') {
        freqBlock.classList.add('is-disabled');
      } else {
        freqBlock.classList.remove('is-disabled');
      }
    }

    function updateTotalBox(container) {
      var selected = container.querySelector('.sbb-card.selected');
      var qtyEl = container.querySelector('[data-summary-qty]');
      var pouchesEl = container.querySelector('.sbb-dynamic-pouches');
      var shipEl = container.querySelector('.sbb-dynamic-shipping');
      var giftEl = container.querySelector('[data-summary-regalos]');
      var totEl = container.querySelector('.sbb-dynamic-total');
      var modeEl = container.querySelector('[data-summary-mode]');
      var totalBox = container.querySelector('.sbb-total-box');

      var lblShippingFree = (totalBox && totalBox.dataset.lblShippingFree) || 'GRATIS';
      var lblGiftFreeTag = (totalBox && totalBox.dataset.lblGiftFreeTag) || 'GRATIS';
      var lblSelectPlan = (totalBox && totalBox.dataset.lblSelectPlan) || 'Selecciona un plan';
      var lblModeOnetime = (totalBox && totalBox.dataset.lblModeOnetime) || 'Compra única';
      var lblModeSubFormat = (totalBox && totalBox.dataset.lblModeSubFormat) || '{freq} · ahorras {amount}';
      var lblCurrency = (totalBox && totalBox.dataset.lblCurrency) || 'MXN';

      if (!selected || selected.classList.contains('sbb-card-empty')) {
        if (qtyEl) qtyEl.textContent = '×0';
        if (pouchesEl) pouchesEl.textContent = fmt(0);
        if (shipEl) { shipEl.textContent = fmt(0); shipEl.classList.remove('free'); }
        if (giftEl) giftEl.innerHTML = '—';
        if (totEl) totEl.textContent = fmt(0) + ' ' + lblCurrency;
        if (modeEl) modeEl.textContent = lblSelectPlan;
        return;
      }

      var mode = selected.dataset.activeMode || 'sub';
      // Items varía por modo: one-time muestra PAID (no recibe bonus),
      // sub muestra TOTAL (paid + bonus)
      var paidCount = parseInt(selected.dataset.paidPouches, 10) || 1;
      var totalCount = parseInt(selected.dataset.totalPouches, 10) || paidCount;
      var items = (mode === 'sub') ? totalCount : paidCount;
      var pouchesValue, shipValue, total, ahorra;

      if (mode === 'sub') {
        total = parseFloat(selected.dataset.computedSubTotal) || 0;
        shipValue = parseFloat(selected.dataset.computedEnvioSub) || 0;
        pouchesValue = total - shipValue;
        ahorra = parseFloat(selected.dataset.computedAhorra) || 0;
      } else {
        pouchesValue = parseFloat(selected.dataset.computedProducto) || 0;
        shipValue = parseFloat(selected.dataset.computedEnvio) || 0;
        total = parseFloat(selected.dataset.computedOnetimeTotal) || 0;
        ahorra = 0;
      }

      if (qtyEl) qtyEl.textContent = '×' + items;
      if (pouchesEl) pouchesEl.textContent = fmt(pouchesValue);
      if (shipEl) {
        if (shipValue === 0) {
          shipEl.textContent = lblShippingFree;
          shipEl.classList.add('free');
        } else {
          shipEl.textContent = fmt(shipValue);
          shipEl.classList.remove('free');
        }
      }
      if (giftEl) {
        var label = selected.dataset.giftLabel || '';
        // Gift SOLO se muestra en modo sub (BOGO no aplica en one-time)
        if (label && mode === 'sub') {
          giftEl.innerHTML = label + '<span class="sbb-free-tag">' + lblGiftFreeTag + '</span>';
        } else {
          giftEl.innerHTML = '—';
        }
      }
      if (totEl) totEl.textContent = fmt(total) + ' ' + lblCurrency;
      if (modeEl) {
        if (mode === 'sub') {
          var freqName = getCurrentFreqName(container);
          var formatted = String(lblModeSubFormat)
            .split('[freq]').join(freqName)
            .split('{freq}').join(freqName)
            .split('[amount]').join(fmt(ahorra))
            .split('{amount}').join(fmt(ahorra));
          modeEl.textContent = formatted;
          modeEl.classList.remove('is-onetime');
        } else {
          modeEl.textContent = lblModeOnetime;
          modeEl.classList.add('is-onetime');
        }
      }
    }

    function initGlobalFreq(container) {
      var globalContainer = container.querySelector('.sbb-global-freq-pills');
      if (!globalContainer) return;
      var freqBlock = container.querySelector('.sbb-global-freq');
      var firstSubSource = container.querySelector('.sbb-card .sbb-frequency-container .sbb-frequency-pill');
      if (!firstSubSource) {
        if (freqBlock) freqBlock.style.display = 'none';
        return;
      }
      var sourcePills = container.querySelectorAll('.sbb-card .sbb-frequency-container .sbb-frequency-pill');
      var firstTier = sourcePills[0].closest('.sbb-card');
      var tierPills = firstTier ? firstTier.querySelectorAll('.sbb-frequency-pill') : [];

      globalContainer.innerHTML = '';
      tierPills.forEach(function(srcPill, idx) {
        var clone = srcPill.cloneNode(true);
        if (idx === 0) clone.classList.add('is-active');
        else clone.classList.remove('is-active');
        clone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          applyGlobalFreq(container, this);
        });
        globalContainer.appendChild(clone);
      });
    }

    function applyGlobalFreq(container, clickedPill) {
      var planId = clickedPill.dataset.planId;
      var globalContainer = container.querySelector('.sbb-global-freq-pills');
      if (globalContainer) {
        globalContainer.querySelectorAll('.sbb-frequency-pill').forEach(function(p) { p.classList.remove('is-active'); });
        clickedPill.classList.add('is-active');
      }

      var settings = readSettings(container);
      var freqPct = parseFloat(clickedPill.dataset.pct) || 0;
      var freqName = clickedPill.dataset.planName || '';

      container.querySelectorAll('.sbb-card').forEach(function(card) {
        if (card.classList.contains('sbb-card-empty')) return;
        card.querySelectorAll('.sbb-frequency-pill').forEach(function(p) {
          if (p.dataset.planId === planId) p.classList.add('is-active');
          else p.classList.remove('is-active');
        });
        if (planId && card.dataset.activeMode === 'sub') {
          card.dataset.sellingPlanId = planId;
        }
        renderTier(card, settings, freqPct, freqName);
      });

      var selected = container.querySelector('.sbb-card.selected');
      if (selected) syncFormInputs(selected);
      updateTotalBox(container);
      publishBuyboxPreview(container);
    }

    function syncFormInputs(tierEl) {
      var variantId = tierEl.dataset.variantId;
      var sellingPlanId = tierEl.dataset.sellingPlanId;
      var nativeInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (nativeInput && variantId) {
        nativeInput.value = variantId;
        nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var planInput = form.querySelector('input[name="selling_plan"]');
        if (sellingPlanId) {
          if (!planInput) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            form.appendChild(planInput);
          }
          planInput.value = sellingPlanId;
        } else if (planInput) {
          planInput.value = '';
        }
      }
    }

    // ─── ATC handlers · ahora con BOGO support ─────────────────────
    function collectFlavorSelections(cardEl) {
      // Devuelve estructura ordenada: array de {variantId, isBonus} en orden de selects
      var selects = cardEl.querySelectorAll('.sbb-flavor-select');
      var ordered = [];
      var missing = 0;
      selects.forEach(function(sel) {
        if (sel.value) {
          ordered.push({
            variantId: sel.value,
            isBonus: sel.dataset.isBonus === 'true'
          });
        } else {
          missing++;
        }
      });
      return { ordered: ordered, missing: missing, totalSelects: selects.length };
    }

    function showError(container, msg) {
      var errEl = container.querySelector('.sbb-add-error');
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.style.display = 'block';
      clearTimeout(errEl._t);
      errEl._t = setTimeout(function() { errEl.style.display = 'none'; }, 4500);
    }

    function clearError(container) {
      var errEl = container.querySelector('.sbb-add-error');
      if (errEl) errEl.style.display = 'none';
    }

    function openCartDrawer() {
      if (typeof window.openDrawer === 'function') { window.openDrawer(); return; }
      var drawer = document.getElementById('CartDrawer');
      var overlay = document.getElementById('CartDrawerOverlay');
      if (drawer) drawer.classList.add('is-active');
      if (overlay) overlay.classList.add('is-active');
    }

    var isAddingToCart = false;

    function setButtonState(container, state) {
      var mainBtn = container.querySelector('[data-sbb-add]');
      var mainText = container.querySelector('.sbb-add-btn-text');
      var mainLoader = container.querySelector('.sbb-add-btn-loader');
      if (mainBtn) {
        mainBtn.classList.remove('is-loading', 'is-success');
        if (state === 'loading') {
          mainBtn.disabled = true;
          mainBtn.classList.add('is-loading');
          if (mainText) mainText.style.display = 'none';
          if (mainLoader) mainLoader.style.display = 'inline-flex';
        } else if (state === 'success') {
          mainBtn.disabled = true;
          mainBtn.classList.add('is-success');
          if (mainText) mainText.style.display = 'none';
          if (mainLoader) mainLoader.style.display = 'none';
        } else {
          mainBtn.disabled = false;
          if (mainText) mainText.style.display = 'inline';
          if (mainLoader) mainLoader.style.display = 'none';
        }
      }

      var stickyBtn = document.querySelector('.propel-sticky-atc [data-sticky-add]');
      if (stickyBtn) {
        stickyBtn.classList.remove('is-loading', 'is-success');
        if (state === 'loading') {
          stickyBtn.disabled = true;
          stickyBtn.classList.add('is-loading');
        } else if (state === 'success') {
          stickyBtn.disabled = true;
          stickyBtn.classList.add('is-success');
        } else {
          stickyBtn.disabled = false;
        }
      }
    }

    function handleAddToCart(container) {
      if (isAddingToCart) {
        console.log('[Smart Buybox] Ya hay un add en curso, ignorando click');
        return;
      }

      var selected = container.querySelector('.sbb-card.selected');
      if (!selected || selected.classList.contains('sbb-card-empty')) {
        showError(container, 'Selecciona un kit primero.');
        return;
      }
      var paidPouchesCount = parseInt(selected.dataset.paidPouches, 10) || 1;
      var bonusPouchesCount = parseInt(selected.dataset.bonusPouches, 10) || 0;
      var totalPouchesCount = parseInt(selected.dataset.totalPouches, 10) || (paidPouchesCount + bonusPouchesCount);
      var sellingPlanId = selected.dataset.sellingPlanId || '';
      var activeMode = selected.dataset.activeMode || 'sub';
      var collected = collectFlavorSelections(selected);
      if (collected.totalSelects === 0) {
        showError(container, 'Este tier no tiene colección de sabores configurada.');
        return;
      }

      // ─── MODO one-time: SIN BOGO ────────────────────────────────────
      // El cliente solo recibe los pouches PAGADOS (no los bonus).
      // Validamos que haya elegido sabor en los slots PAID; los bonus se ignoran.
      // Modo sub: SÍ BOGO — valida todos los slots (paid + bonus).
      var requiredCount = (activeMode === 'onetime') ? paidPouchesCount : totalPouchesCount;
      var missingRequired = 0;
      collected.ordered.forEach(function(entry) {
        // Si es slot bonus y estamos en one-time, no cuenta como requerido
        if (entry.isBonus && activeMode === 'onetime') return;
        if (!entry.variantId) missingRequired++;
      });
      // Fallback: si el collected.missing incluye slots faltantes visibles
      if (missingRequired === 0 && collected.missing > 0) {
        // En sub: todos los missing cuentan. En one-time: solo paid cuentan
        if (activeMode === 'sub') missingRequired = collected.missing;
      }
      if (missingRequired > 0) {
        showError(container, 'Elige los ' + requiredCount + ' sabores antes de continuar.');
        return;
      }
      clearError(container);

      // ─── Construir line items · BOGO solo si activeMode === 'sub' ───
      // Cada select tiene data-is-bonus="true" en los últimos N slots (bonus_pouches).
      // Los bonus se envían como _gift SOLO si el modo es sub.
      // En one-time, los bonus se IGNORAN completamente (el cliente no los recibe).
      var paidGroup = {};
      var giftGroup = {};

      collected.ordered.forEach(function(entry) {
        var vId = parseInt(entry.variantId, 10);
        if (vId <= 0) return;
        if (entry.isBonus) {
          // Bonus slot: solo se agrega si estamos en modo sub
          if (activeMode === 'sub') {
            giftGroup[vId] = (giftGroup[vId] || 0) + 1;
          }
          // Si es onetime, ignoramos (el cliente no recibe bonus)
        } else {
          // Paid slot: siempre se agrega
          paidGroup[vId] = (paidGroup[vId] || 0) + 1;
        }
      });

      var lineItems = [];

      // 1) Paid items (con selling_plan si aplica)
      Object.keys(paidGroup).forEach(function(vIdStr) {
        var vId = parseInt(vIdStr, 10);
        var qty = paidGroup[vIdStr];
        var item = { id: vId, quantity: qty };
        if (sellingPlanId && activeMode === 'sub') {
          item.selling_plan = parseInt(sellingPlanId, 10);
        }
        lineItems.push(item);
      });

      // 2) Gift items (BOGO — solo si activeMode === 'sub')
      Object.keys(giftGroup).forEach(function(vIdStr) {
        var vId = parseInt(vIdStr, 10);
        var qty = giftGroup[vIdStr];
        // Los gifts NO tienen selling_plan (sub no aplica a gifts individualmente,
        // pero como el kit es sub, van juntos en el cart y suman al recurring)
        lineItems.push({
          id: vId,
          quantity: qty,
          properties: { '_gift': 'true', '_bogo_source': 'buybox_' + paidPouchesCount + 'p_sub' }
        });
      });

      // Filter defensivo
      lineItems = lineItems.filter(function(item) {
        return item.id > 0 && item.quantity > 0;
      });

      if (lineItems.length === 0) {
        showError(container, 'Error en la selección. Refresca la página.');
        return;
      }

      var totalPaidQty = Object.values(paidGroup).reduce(function(s, q) { return s + q; }, 0);
      var totalGiftQty = Object.values(giftGroup).reduce(function(s, q) { return s + q; }, 0);
      console.log('[Smart Buybox] Agregando al carrito:', {
        tier: paidPouchesCount + '+' + bonusPouchesCount + ' pouches',
        mode: activeMode,
        paidQty: totalPaidQty,
        bogoQty: totalGiftQty + (activeMode === 'onetime' && bonusPouchesCount > 0 ? ' (IGNORADO en one-time)' : ''),
        sellingPlanId: sellingPlanId || '(none)',
        lineItems: lineItems,
        totalQty: lineItems.reduce(function(sum, it) { return sum + it.quantity; }, 0)
      });

      isAddingToCart = true;
      setButtonState(container, 'loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lineItems })
      })
        .then(async function(r) {
          const text = await r.text();
          let data = null;
          try {
            data = JSON.parse(text);
          } catch (parseErr) {
            console.error('[Smart Buybox] ✗ Respuesta NO es JSON:', {
              status: r.status,
              statusText: r.statusText,
              headers: Object.fromEntries(r.headers.entries()),
              bodyPreview: text.substring(0, 500),
              requestSent: { items: lineItems }
            });

            const lowerText = text.toLowerCase();
            if (lowerText.includes('password') || lowerText.includes('contraseña')) {
              throw new Error('La tienda está en modo password. Desactívalo en Shopify Admin > Online Store > Preferences.');
            }
            if (lowerText.includes('not found') || r.status === 404) {
              throw new Error('Producto no encontrado. Verifica que el variant exista y esté disponible.');
            }
            if (r.status === 422 || lowerText.includes('selling_plan')) {
              throw new Error('Plan de suscripción inválido para este producto.');
            }
            if (r.status === 500 || r.status === 502 || r.status === 503) {
              throw new Error('Error temporal del servidor. Intenta de nuevo en un momento.');
            }
            if (r.status === 0 || lowerText.includes('preview_theme')) {
              throw new Error('Modo preview detectado. Algunas operaciones del cart no funcionan en preview.');
            }
            throw new Error('Respuesta inesperada (Status ' + r.status + '). Revisa la consola.');
          }

          if (!r.ok) {
            console.error('[Smart Buybox] ✗ Error de Shopify:', data);
            throw new Error(data.description || data.message || 'Error HTTP ' + r.status);
          }
          return data;
        })
        .then(function(response) {
          console.log('[Smart Buybox] ✓ Agregados con éxito:', response);
          setButtonState(container, 'success');

          setTimeout(function() {
            openCartDrawer();
            setTimeout(function() {
              setButtonState(container, 'idle');
              isAddingToCart = false;
            }, 500);
          }, 350);
        })
        .catch(function(err) {
          console.error('[Smart Buybox] ✗ Error al agregar:', err);
          setButtonState(container, 'idle');
          isAddingToCart = false;
          var userMsg = err.message || 'No se pudo agregar al carrito. Intenta de nuevo.';
          if (userMsg.indexOf('<') !== -1 || userMsg.indexOf('JSON') !== -1) {
            userMsg = 'No se pudo conectar con el carrito. Verifica tu conexión e intenta de nuevo.';
          }
          showError(container, userMsg);
        });
    }

    // ─── Auto-popular gift chip desde el kit (SOLO fallback) ────────
    // El tier renderiza su propio gift_label directo desde Liquid.
    // Esta función solo actúa cuando el tier NO tiene gift_label configurado
    // — entonces auto-genera desde el kit correspondiente:
    //   1. Si kit.pouchesBonus > 0 → "N pouch(es) GRATIS"
    //   2. Fallback: milestone al threshold del tier
    function populateGiftChipFromKit(tierEl) {
      var chip = tierEl.querySelector('[data-gift-chip]');
      if (!chip) return;
      var textEl = chip.querySelector('[data-gift-label-text]');
      if (!textEl) return;

      // Si el tier YA tiene texto configurado en Liquid, no tocamos
      var existingText = (textEl.textContent || '').trim();
      if (existingText) {
        chip.style.display = 'inline-flex';
        tierEl.dataset.giftLabel = existingText;
        return;
      }

      var paidPouches = parseInt(tierEl.dataset.paidPouches || tierEl.dataset.itemsCount, 10) || 0;
      var giftLabel = '';

      // 1) Kit lookup
      if (window.PROPEL_KITS && typeof window.PROPEL_KITS.getKitByPouchesPaid === 'function') {
        var kit = window.PROPEL_KITS.getKitByPouchesPaid(paidPouches);
        if (kit && kit.pouchesBonus > 0) {
          giftLabel = kit.pouchesBonus + ' pouch' + (kit.pouchesBonus > 1 ? 'es' : '') + ' GRATIS';
        }
      }

      // 2) Milestone fallback
      if (!giftLabel && window.PROPEL_MILESTONES && typeof window.PROPEL_MILESTONES.findByThreshold === 'function') {
        var ms = window.PROPEL_MILESTONES.findByThreshold(paidPouches);
        if (ms && ms.benefit) giftLabel = ms.benefit;
      }

      if (giftLabel) {
        textEl.textContent = giftLabel;
        chip.style.display = 'inline-flex';
        tierEl.dataset.giftLabel = giftLabel;
      } else {
        chip.style.display = 'none';
        tierEl.dataset.giftLabel = '';
      }
    }

    // Alias para consumers
    function populateTierFromKit(tierEl) { populateGiftChipFromKit(tierEl); }

    function initSbb(container) {
      var settings = readSettings(container);

      initGlobalFreq(container);

      var initialPlanId = getCurrentFreqPlanId(container);
      container.querySelectorAll('.sbb-card').forEach(function(card) {
        if (card.classList.contains('sbb-card-empty')) return;
        if (!card.dataset.activeMode) card.dataset.activeMode = 'sub';
        if (initialPlanId) card.dataset.sellingPlanId = initialPlanId;
      });

      var initialFreqPct = getCurrentFreqPct(container);
      var initialFreqName = getCurrentFreqName(container);
      container.querySelectorAll('.sbb-card').forEach(function(card) {
        if (!card.classList.contains('sbb-card-empty')) {
          populateGiftChipFromKit(card);   // auto-populate gift desde kit
          renderTier(card, settings, initialFreqPct, initialFreqName);
        }
      });

      container.querySelectorAll('.sbb-mode-col').forEach(function(col) {
        col.addEventListener('click', function(e) {
          if (e.target.closest('.sbb-flavors-container')) return;
          if (e.target.closest('.sbb-frequency-pill')) return;
          selectModeCol(this);
        });
      });

      var addBtn = container.querySelector('[data-sbb-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function(e) {
          e.preventDefault();
          handleAddToCart(container);
        });
      }

      var firstTier = container.querySelector('.sbb-card:not(.sbb-card-empty)');
      if (firstTier) {
        var subCol = firstTier.querySelector('.sbb-mode-col-sub');
        if (subCol) selectModeCol(subCol);
      }

      // ─── Re-render cuando PROPEL_KITS o PROPEL_MILESTONES cargan después ──
      // Ambos eventos triggerean re-render completo del tier + gift chip.
      function reRenderAll() {
        var freshSettings = readSettings(container);
        var freshFreqPct = getCurrentFreqPct(container);
        var freshFreqName = getCurrentFreqName(container);
        container.querySelectorAll('.sbb-card').forEach(function(card) {
          if (!card.classList.contains('sbb-card-empty')) {
            populateGiftChipFromKit(card);
            renderTier(card, freshSettings, freshFreqPct, freshFreqName);
          }
        });
        updateTotalBox(container);
      }
      document.addEventListener('propel:kits-loaded', reRenderAll);
      document.addEventListener('propel:milestones-loaded', reRenderAll);
    }

    function hideNativeAddToCart() {
      var anyHide = false;
      document.querySelectorAll('.sbb-container').forEach(function(c) {
        if (c.dataset.hideNativeAtc === '1') anyHide = true;
      });
      if (!anyHide) return;
      document.body.classList.add('sbb-hide-native-atc');
      var selectors = [
        '.buy-buttons-block',
        'product-form-component',
        '[id^="BuyButtons-ProductForm-"]',
        '.add-to-cart-button',
        '[id^="BuyButtons-ProductSubmitButton-"]'
      ];
      function applyHide() {
        selectors.forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(el) {
            el.style.setProperty('display', 'none', 'important');
          });
        });
      }
      applyHide();
      setTimeout(applyHide, 500);
      setTimeout(applyHide, 1500);
    }

    function initAll() {
      hideNativeAddToCart();
      document.querySelectorAll('.sbb-container').forEach(initSbb);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
